import { useDashboardFolderListModel } from './dashboard-folder-list.model'
import { DashboardFolderListView } from './dashboard-folder-list.view'

export const DashboardFolderList = () => {
  const dashboardFolderListModel = useDashboardFolderListModel()
  return <DashboardFolderListView {...dashboardFolderListModel} />
}
